import { HStack, Icon, useClipboard, IconButton, useToast } from "@chakra-ui/react";
import { MdContentCopy } from "react-icons/md";
import { Text14 } from "components/Text";
import { IconType } from "react-icons";
import { ReactNode } from "react";

interface AttributeRowProps {
  icon: IconType;
  label: string;
  value?: string | ReactNode;
  copyable?: boolean;
}

export default function AttributeRow({ icon, label, value, copyable = false }: AttributeRowProps) {
  const { onCopy } = useClipboard(typeof value === "string" ? value : "");
  const toast = useToast();

  const handleCopy = () => {
    onCopy();
    toast({
      title: "Copied",
      status: "success",
      duration: 1500,
      isClosable: true,
    });
  };

  if (!value) return null;

  return (
    <HStack justify="space-between" w="100%">
      <HStack spacing={2} flex="0 0 auto">
        <Icon as={icon} color="gray.500" boxSize={4} />
        <Text14 fontWeight="medium" color="gray.700">
          {label}
        </Text14>
      </HStack>
      <HStack spacing={1} flex="1" justify="flex-end" minW={0}>
        {typeof value === "string" ? (
          <Text14 noOfLines={1} textAlign="right">
            {value}
          </Text14>
        ) : (
          value
        )}
        {copyable && typeof value === "string" && (
          <IconButton
            aria-label={`Copy ${label}`}
            icon={<MdContentCopy />}
            size="xs"
            variant="ghost"
            onClick={handleCopy}
            color="gray.500"
            minW="auto"
            h="auto"
          />
        )}
      </HStack>
    </HStack>
  );
}
